var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.1484H7C3.35 22.1484 1.25 20.0484 1.25 16.3984V9.39844C1.25 5.74844 3.35 3.64844 7 3.64844H17C20.65 3.64844 22.75 5.74844 22.75 9.39844V16.3984C22.75 20.0484 20.65 22.1484 17 22.1484ZM7 5.14844C4.14 5.14844 2.75 6.53844 2.75 9.39844V16.3984C2.75 19.2584 4.14 20.6484 7 20.6484H17C19.86 20.6484 21.25 19.2584 21.25 16.3984V9.39844C21.25 6.53844 19.86 5.14844 17 5.14844H7Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 13.7664C11.1598 13.7664 10.3098 13.5065 9.65978 12.9765L6.52978 10.4765C6.20978 10.2165 6.14978 9.74645 6.40978 9.42645C6.66978 9.10645 7.13978 9.04646 7.45978 9.30646L10.5898 11.8065C11.3498 12.4165 12.6398 12.4165 13.3998 11.8065L16.5298 9.30646C16.8498 9.04646 17.3298 9.09645 17.5798 9.42645C17.8398 9.74645 17.7898 10.2265 17.4598 10.4765L14.3298 12.9765C13.6898 13.5065 12.8398 13.7664 11.9998 13.7664Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.722b5a7f957fdbb40fa00f6fcaeb59ed.svg";
export { ForwardRef as ReactComponent };